import {NgModule} from '@angular/core';
import {Routes, RouterModule, ExtraOptions} from '@angular/router';
import {AuthGuardService as AuthGuard} from './core/guards';

const routes: Routes = [
  {
    path: 'app',
    loadChildren: () => import('./views/app-wrapper/app-wrapper.module')
      .then(m => m.AppWrapperModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'payroll',
    loadChildren: () => import('./views/wrapper/wrapper.module')
      .then(m => m.WrapperModule),
    canActivate: [AuthGuard]
  }, {
    path: 'login',
    loadChildren: () => import('./views/auth/login/login.module')
      .then(m => m.LoginModule),
    canActivate: [AuthGuard]
  }, {
    path: 'redirect',
    loadChildren: () => import('./views/redirect/redirect.module')
      .then(m => m.RedirectModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'reset-password',
    loadChildren: () => import('./views/auth/reset-password/reset-password.module')
      .then(m => m.ResetPasswordModule),
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./views/auth/forgot-password/forgot-password.module')
      .then(m => m.ForgotPasswordModule),
  },
  {
    path: 'paysliprequest',
    loadChildren: () => import('./views/auth/request-payslip/request-payslip.module')
      .then(m => m.RequestPayslipModule),
  },
  {
    path: 'login/dbd',
    loadChildren: () => import('./views/authen-sso/authen-sso.module')
      .then(m => m.AuthenSsoModule)
  },
  {path: '', redirectTo: 'redirect', pathMatch: 'full'},
  {path: '**', redirectTo: 'redirect'}
];

const config: ExtraOptions = {
  // enableTracing: true,
  scrollPositionRestoration: 'enabled'
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
